// extracted by mini-css-extract-plugin
export default {"tableRow":"List_tableRow__cTvdu","tableCell":"List_tableCell__EZRcG"};